/**
 * global 通用全局对象/方法
 * · 在单文件中通过 this.$xxx 的方式调用
 */
import Vue from 'vue'

import api from '@/api'
import {Ticket, Storage, isEmpty, deepClone} from '@/utils'

Vue.prototype.$api = api
Vue.prototype.$ticket = Ticket
Vue.prototype.$storage = Storage
Vue.prototype.$isEmpty = isEmpty
Vue.prototype.$deepClone = deepClone

window.console.color = (param1, ...args) => {
    console.log(`%c ${param1} `, 'background:#42A5F5;color:#fff', ...args)
}

// 全局捕获所有未处理的异常
// window.addEventListener('unhandledrejection', event => {
//     const {reason} = event
//
//     let serverMessage = reason.message || reason.data?.message
//     if (serverMessage) {
//         console.error(serverMessage)
//     }
//
//     event.preventDefault();
// })
